// @flow
import React, { Component } from 'react';
import MainTemplate from 'components/main/MainTemplate';
import { connect } from 'react-redux';
import type { State } from 'store';
import { type ContextRouter, Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Trending from 'pages/Trending';
import Recent from 'pages/Recent';
import Display from 'pages/Display';
import Bannering from 'pages/Bannering';
import Branding from 'pages/Branding';
import Eventing from 'pages/Eventing';
import Lettering from 'pages/Lettering';
import Quoting from 'pages/Quoting';
import Partnering from 'pages/Partnering';
import Tags from 'pages/Tags';
import Sections from 'pages/Sections';
import ProductsTags from 'pages/ProductsTags';
import Categories from 'pages/Categories';

type Props = {
  landing: boolean,
} & ContextRouter;

class MainContainer extends Component<Props> {
  render() {
    return (
      <MainTemplate>
        <Switch>
          <Route exact path="/" component={Trending} />
          <Route path="/posts" component={Recent} />
          <Route exact path="/products" component={Display} />
          <Route path="/banners" component={Bannering} />
          <Route path="/partners" component={Branding} />
          <Route path="/events" component={Eventing} />
          <Route path="/letters" component={Lettering} />
          <Route path="/quotes" component={Quoting} />
          <Route path="/brands" component={Partnering} />
          <Route path="/tags/:tag?" component={Tags} />
          <Route path="/sections/:section?" component={Sections} />
          <Route path="/products/tags/:tag?" component={ProductsTags} />
          <Route path="/categories/:category?" component={Categories} />
        </Switch>
      </MainTemplate>
    );
  }
}

export default compose(
  withRouter,
  connect(
    ({ base }: State) => ({
      landing: base.landing,
    }),
    () => ({}),
  ),
)(MainContainer);



// WEBPACK FOOTER //
// ./src/containers/main/MainContainer.js